import { Check } from '@sparkware/app-utils';
import { ServiceBase } from '../ServiceBase';
import { IServiceFactoryExtended } from '../service-factory-extended.interface';
import { IHttpService } from './http.service.interface';
import { HttpService } from './http.service';


export class HttpWithRequestTimeMeasurement extends ServiceBase implements IHttpService {

  constructor(services: IServiceFactoryExtended, private readonly _decoratedHttpService: HttpService) {
    super(services);
  }

  async get(url: string, options?: RequestInit): Promise<any> {
    const fetchedResponse = await this.fetchResponseWitLoadTimeReporting(url,'GET', options);
    const parsedResponse = await this.parseResponseWitLoadTimeReporting(url, fetchedResponse)
    return parsedResponse;
  }

  async post(url: string, options?: RequestInit): Promise<any> {
    const fetchedResponse = await this.fetchResponseWitLoadTimeReporting(url, 'POST', options);
    const parsedResponse = await this.parseResponseWitLoadTimeReporting(url, fetchedResponse)
    return parsedResponse;
  }

  fetchResponse(url: string, method: string, options?: RequestInit): Promise<Response> {
    return this._decoratedHttpService._fetchResponse(url, method, options);
  }
  parseResponse(response: Response): Promise<any> {
    return this._decoratedHttpService._parseResponse(response);
  }

  createUrlSearchParams(): URLSearchParams {
    return this._decoratedHttpService.createUrlSearchParams();
  }

  createHeaders(): Headers {
    return this._decoratedHttpService.createHeaders();
  }

  private async fetchResponseWitLoadTimeReporting(url: string, method: string, options?: RequestInit): Promise<Response> {
    const startTime = this.services.time.performanceNow();
    const fetchedResponse = await this._decoratedHttpService._fetchResponse(url,method, options);
    const endTime = this.services.time.performanceNow();

    this._reportDuration(url, 'REQUEST_TIME', startTime, endTime);
    return fetchedResponse;
  }
  
  private async parseResponseWitLoadTimeReporting(url: string, response: Response): Promise<Response> {
    const startTime = this.services.time.performanceNow();
    const parsedResponse = await this._decoratedHttpService._parseResponse(response);
    const endTime = this.services.time.performanceNow();

    this._reportDuration(url, 'RESPONSE_PARSE_TIME', startTime, endTime);
    return parsedResponse;
  }

  private _reportDuration(url: string, action:string, startTime: number, finishTime: number): void {
    try {
        if(Check.isNullOrUndefined(startTime) || Check.isNullOrUndefined(finishTime)){
            return;
        }
        const duration = finishTime - startTime;
        this.services.sdk.structuredLoggingService
            .getLogger()
            .addCategory('HTTP_REQUEST')
            .addAction(action)
            .addLabel(url)
            .addValue(duration.toString())
            .info();
    }
    catch (e) {
        this.services.logger.error(`Error while reporting http request load time for ${url}!`);
    }
  }
}
